import base_getters from '@/store/modules/base/getters.js'

export default {
    ...base_getters
}